export const GAUGES_NOTIFICATIONS_STORE_KEY = 'gauges_notifications';

type StoreKeys = typeof GAUGES_NOTIFICATIONS_STORE_KEY;

export function retrieveStoredDataFromLocalStorage<T>(key: StoreKeys): T | null {
    const serializedData = localStorage.getItem(key);

    if (serializedData) {
        try {
            return JSON.parse(serializedData);
        } catch {
            return null;
        }
    }

    return null;
}

export function storeDataToLocalStorage<T>(key: StoreKeys, data: T): void {
    localStorage.setItem(key, JSON.stringify(data));
}
